import React from "react";
import Settings from "../../../content/json/components/settings.json";
import { NavLink } from "react-router-dom";
import $ from "jquery";
import { msalAuth } from "../../../api/msal/MsalAuthProvider";
import TreeChildren from "./TreeChildren";
import MyContext from "../../../api/context/my-context";
import SideMenuBottom from "./SideMenuBottom";
import * as Common from "../../common/common";
import * as omnimap from "../../../api/omnimap/omnimapActions";
class SideMenu extends React.Component {
  constructor(props) {
    super(props);
    this.handleEvent = this.handleEvent.bind(this);

    this.state = {
      tabName: props.tabName,
      menuName: props.menuName,
      token: null,
      treeList: [],
      treeCount: 0,
      treekey: props.treekey,
      pureTree: [],
      isLoading: true,
    };
  }
  handleEvent() {
    var tree = this.state.treeList;
    var pureTree = this.state.pureTree;
    this.state = {
      tabName: this.props.tabName,
      menuName: this.props.menuName,
      token: this.state.token,
      treeList: tree,
      treekey: this.props.treekey,
      pureTree: pureTree,
      isLoading: this.state.isLoading,
      // treeCount: this.state.treeCount,
    };
  }

  list = [];
  model = {
    content: [
      {
        key: "algemeen-isvoor",
        and_or: "AND",
        values: [this.props.treekey],
        datatype: "STRING",
      },
    ],
    context: [],
    timestamps: [],
    definitions: [process.env.REACT_APP_TREE],
    statuses: [],
  };

  async GetTreeStructure(model) {
    this.setState({ isLoading: true });
    var that = this;

    await Common.GetTreeStructurePure("", model, that.state.token).then(
      function (pureTreeList) {
        if (pureTreeList != undefined) {
          that.setState({ pureTree: pureTreeList });
        } else {
          that.setState({ pureTree: [] });
        }
      }
    );

    await Common.GetTreeStructure("", model, that.state.token).then(function (
      TreeResult
    ) {
      if (TreeResult != undefined) {
        that.setState({ treeList: [] });
        that.setState({
          treeList: TreeResult.treeList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            return 0;
          }),
          isLoading: false,
        });
        window.$catalog_management_units_treeList = TreeResult.treeList;
        that.setState({ treeCount: TreeResult.treecount });
      } else {
        that.setState({ treeList: [], isLoading: false });
        that.setState({ treeCount: null });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    var that = this;
    if (prevProps.treekey != that.state.treekey) {
      var model = {
        content: [
          {
            key: "algemeen-isvoor",
            and_or: "AND",
            values: [that.state.treekey],
            datatype: "STRING",
          },
        ],
        definitions: [process.env.REACT_APP_TREE],
      };

      $("#side-menu-treeButton").click();
    }
  }

  async componentDidMount() {
    await this.GetTreeStructure(this.model);
  }

  render() {
    this.handleEvent();
    if (this.state.menuName === "settings") {
      var menuList = Settings.menus;
    }
    return (
      <div>
        <ul className="left-menu ul">
          {menuList.map((s) => (
            <div>
              {s.componentName === this.state.tabName ? (
                <li key={s.id.toString()}>
                  <NavLink
                    className="icon-filter-act"
                    to={{
                      pathname:
                        "/" + this.state.menuName + "/" + s.componentName,
                      componentName: s.componentName,
                      isDidUpdate: "0038",
                    }}
                  >
                    <span className={s.icon} />
                    {s.name}
                    <span
                      class={
                        s.isTree && this.state.isLoading
                          ? "spinner-border spinner-border-sm"
                          : ""
                      }
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </NavLink>
                </li>
              ) : (
                <li key={s.id.toString()}>
                  <NavLink
                    className=""
                    to={{
                      pathname:
                        "/" + this.state.menuName + "/" + s.componentName,
                      componentName: s.componentName,
                      isDidUpdate: "0038",
                    }}
                  >
                    <span className={s.icon} />
                    {s.name}
                  </NavLink>
                </li>
              )}
              {s.isTree ? (
                this.state.treeList.length > 0 ? (
                  s.componentName === this.state.tabName ? (
                    <MyContext.Consumer>
                      {(context) => (
                        <div>
                          <TreeChildren
                            TreeList={
                              context.store.treeCount == null
                                ? this.state.treeList
                                : context.store.treeCount !=
                                  this.state.treeCount
                                ? context.store.treeList
                                : this.state.treeList
                            }
                            TreeCountUpdate={context.store.treeCount}
                            TreeCount={this.state.treeCount}
                            componentName={s.componentName}
                            pathname={this.state.menuName}
                            pureTree={this.state.pureTree}
                          />
                        </div>
                      )}
                    </MyContext.Consumer>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </div>
          ))}
        </ul>

        <SideMenuBottom />
        <MyContext.Consumer>
          {(context) => (
            <div hidden>
              <button
                id="side-menu-treeButton"
                onClick={() => context.actions.addTask([])}
              >
                + add
              </button>
            </div>
          )}
        </MyContext.Consumer>
      </div>
    );
  }
}

export default SideMenu;
